import { getUrlNew, apis } from '@/config';
import { mailBoxOfVirus } from './mail_action_store_model';
import { api } from '@/api/api';
import { MailAbstractHandler } from './mail_abs_handler';
import { CORP_FOLDER_ERRCODE_MAP, CORP_DEFAULT_ERROR_MSG, NETEASE_DOMAIN_ARR, FEATURE_NAME_TO_NETEASE_WEB_URL } from './corp/const';
const systemApi = api.getSystemApi();
export class MailFuncToCorpMailUrlMap {
    constructor() {
        this.listFolder = getUrlNew('corpMailGetAllFolders');
        this.listItem = getUrlNew('corpMailListMessages');
        this.listContent = getUrlNew('corpMailReadMessage');
        this.getContentByIds = getUrlNew('corpMailGetMessageIfnos');
        this.postMail = getUrlNew('corpMailComponse');
        this.cancelDeliver = getUrlNew('corpMailCancel');
        this.immediateDeliver = getUrlNew('corpMailImmediateDeliver');
        this.checkPostMail = getUrlNew('corpMailListDeliverHistory');
        this.withdrawSending = getUrlNew('corpMailRecallMessage');
        this.getTaglist = getUrlNew('corpMailListTags');
        this.getAttr = getUrlNew('corpMailGetUserAttrs');
        this.updateMail = getUrlNew('corpMailUpdateMessageInfos');
        this.deleteMail = getUrlNew('corpMailDeleteMail');
        this.searchMail = getUrlNew('corpMailSearchMessages');
        this.replyMail = getUrlNew('corpMailReplyMail');
        this.forwardMail = getUrlNew('corpMailForwardMessages');
        this.uploadPrepare = getUrlNew('corpMailUploadPrepare');
        this.upload = getUrlNew('corpMailUpload');
        this.setAttr = getUrlNew('corpMailSetUserAttrs');
        this.markAllMail = getUrlNew('corpMailMarkSeen');
        this.emptyFolder = getUrlNew('corpMailEmptyFolder');
        this.editDraft = getUrlNew('corpMailRestoreDraft');
        this.editMail = getUrlNew('corpMailEditMessage');
        this.getSignature = getUrlNew('corpMailGetSign');
        this.createSignature = getUrlNew('corpMailCreateSign');
        this.deleteSignature = getUrlNew('corpMailDeleteSign');
        this.updateSignature = getUrlNew('corpMailUpdateSign');
        this.aliasAccount = getUrlNew('corpMailGetAlias');
        this.manageTag = getUrlNew('corpMailManageTags');
        this.updateMessageTags = getUrlNew('corpMailUpdateMessageTags');
        this.updateThreadTags = getUrlNew('corpMailUpdateMessageTags');
        this.threadMail = getUrlNew('corpMailListThreads');
        this.threadMailDetail = getUrlNew('corpMailGetThreadMessageInfos');
        this.getMailPart = getUrlNew('corpMailGetMessageData');
        this.downloadTmpAttachment = getUrlNew('corpMailGetTmpAttachment');
        this.cancelCompose = getUrlNew('corpMailCancelCompose');
        this.createUserFolder = getUrlNew('corpCreateUserFolder');
        this.updateUserFolder = getUrlNew('corpUpdateUserFolder');
        this.deleteUserFolder = getUrlNew('corpDeleteUserFolder');
        this.getFolderStat = getUrlNew('corpStatsFolder');
        this.threadMailList = getUrlNew('corpMailListThreads');
        this.threadMailInfoDetail = getUrlNew('corpMailGetMessageIfnos');
    }
}
export const mailFuncToCorpMailUrlMap = new MailFuncToCorpMailUrlMap();
export function getUrlByMailFuncName(funcName) {
    const result = mailFuncToCorpMailUrlMap[funcName];
    return result || '';
}
function getPathNameOfUrl(url) {
    const urlObj = new URL(url);
    return urlObj.pathname;
}
const corpMailFolderIdToMailBoxConfMap = {
    6: mailBoxOfVirus,
};
function getHMailFolderItemByCorpMailFolder(item, parent = 0) {
    const newItem = Object.assign(item, { parent });
    if (!newItem.stats) {
        newItem.stats = {};
    }
    const mailConf = corpMailFolderIdToMailBoxConfMap[newItem.id];
    if (mailConf) {
        newItem.id = mailConf.id;
    }
    return newItem;
}
function traversalNestedFolder(folderItem, result) {
    const childrenOfFolderItem = folderItem.children || [];
    childrenOfFolderItem.forEach(childItem => {
        const newItem = getHMailFolderItemByCorpMailFolder(childItem, folderItem.id);
        result.push(newItem);
        traversalNestedFolder(newItem, result);
    });
}
function getCorpResponseDataFromResponse(res) {
    var _a, _b;
    return (_b = (_a = res === null || res === void 0 ? void 0 : res.data) === null || _a === void 0 ? void 0 : _a.data) === null || _b === void 0 ? void 0 : _b.result;
}
function transformFolders(res) {
    const resData = res === null || res === void 0 ? void 0 : res.data;
    const mailFolderArr = (getCorpResponseDataFromResponse(res) || []);
    const nestedFolders = [];
    const hMailFolderArr = mailFolderArr.map((item) => {
        const newItem = getHMailFolderItemByCorpMailFolder(item);
        if (newItem.children && newItem.children.length) {
            traversalNestedFolder(newItem, nestedFolders);
        }
        return newItem;
    });
    resData.var = [...hMailFolderArr, ...nestedFolders];
    return res;
}
function transformMailList(res) {
    var _a;
    const resData = res === null || res === void 0 ? void 0 : res.data;
    const mailList = (getCorpResponseDataFromResponse(res) || []);
    const hMailList = mailList.map(mailItem => {
        const newItem = Object.assign({ attachments: [], recallable: false, encpwd: null, modifiedDate: null, receivedDate: null }, mailItem);
        newItem.modifiedDate = newItem.modifiedDate || mailItem.sentDate;
        return newItem;
    });
    resData.var = hMailList;
    resData.total = ((_a = resData === null || resData === void 0 ? void 0 : resData.data) === null || _a === void 0 ? void 0 : _a.total) || mailList.length;
    return res;
}
function transformMailItem(res) {
    var _a;
    const resData = res === null || res === void 0 ? void 0 : res.data;
    const corpMailContent = getCorpResponseDataFromResponse(res);
    const hmalilFormatmailContent = Object.assign({}, corpMailContent);
    if ((_a = hmalilFormatmailContent === null || hmalilFormatmailContent === void 0 ? void 0 : hmalilFormatmailContent.html) === null || _a === void 0 ? void 0 : _a.content.length) {
        hmalilFormatmailContent.html.content = hmalilFormatmailContent.html.content.replace(/_src=/gi, 'src=');
        hmalilFormatmailContent.html.content = hmalilFormatmailContent.html.content.replace(/_href=/gi, 'href=');
    }
    resData.var = hmalilFormatmailContent;
    return res;
}
function transformSignatures(res) {
    const resData = res === null || res === void 0 ? void 0 : res.data;
    const currentUser = systemApi.getCurrentUser();
    const signatureList = getCorpResponseDataFromResponse(res) || [];
    resData.data = signatureList.map(item => {
        const newItem = {
            signId: item.id,
            signInfoDTO: {
                signId: item.id,
                profilePhoto: '',
                name: currentUser === null || currentUser === void 0 ? void 0 : currentUser.nickName,
                position: '',
                companyName: currentUser === null || currentUser === void 0 ? void 0 : currentUser.company,
                emailAddr: currentUser === null || currentUser === void 0 ? void 0 : currentUser.id,
                phoneNo: '',
                addr: '',
                isSetDefault: item.isDefault,
                signTemplateUrl: '',
                signTemplateId: '',
                showAppVipTag: false,
                signName: '',
                userAddItem: null,
            },
            isFromApp: true,
            divContent: item.content,
            htmlContent: '',
        };
        return newItem;
    });
    return res;
}
function transformForwardMail(res) {
    var _a;
    const resData = res === null || res === void 0 ? void 0 : res.data;
    const composeInfo = (_a = getCorpResponseDataFromResponse(res)) === null || _a === void 0 ? void 0 : _a.compose;
    resData.data.var = composeInfo;
    return res;
}
function transformMailInfos(res) {
    const resData = res === null || res === void 0 ? void 0 : res.data;
    const corpMailInfoArr = getCorpResponseDataFromResponse(res) || [];
    const newMailInfos = corpMailInfoArr;
    resData.var = newMailInfos;
    delete resData.data;
    return res;
}
function transformTagsManage(res) {
    return res;
}
function transformTagList(res) {
    const resData = res === null || res === void 0 ? void 0 : res.data;
    const tagList = getCorpResponseDataFromResponse(res) || [];
    tagList.forEach((tagItem) => {
        var _a;
        const tagId = tagItem[0];
        const tagAttrs = tagItem[1];
        if (tagAttrs) {
            tagAttrs.tagId = tagId;
            tagAttrs.color = Number.parseInt((_a = tagAttrs.color) === null || _a === void 0 ? void 0 : _a.toString(), 10);
            if (tagAttrs.name) {
                tagItem[0] = tagAttrs.name;
            }
            if (tagAttrs.alias) {
                tagItem[0] = tagAttrs.alias;
            }
        }
    });
    resData.var = tagList;
    delete resData.data;
    return res;
}
function transformMailCompose(res) {
    const resData = res === null || res === void 0 ? void 0 : res.data;
    const result = getCorpResponseDataFromResponse(res);
    delete resData.result;
    resData.var = result;
    return res;
}
function transformPreUpload(res) {
    const resData = res === null || res === void 0 ? void 0 : res.data;
    const corpData = getCorpResponseDataFromResponse(res);
    const newData = Object.assign({}, corpData);
    delete resData.result;
    resData.var = newData;
    return res;
}
function transformResultToVar(res) {
    const resData = res === null || res === void 0 ? void 0 : res.data;
    const result = getCorpResponseDataFromResponse(res);
    resData.var = result;
    return res;
}
function transformThreadList(res) {
    var _a, _b;
    transformResultToVar(res);
    const list = ((_a = res === null || res === void 0 ? void 0 : res.data) === null || _a === void 0 ? void 0 : _a.var) || [];
    list.forEach((item) => {
        var _a;
        const fromStr = (item === null || item === void 0 ? void 0 : item.from) || '';
        item.from = fromStr.replace(/^"(-|\+)/, '"');
        item.threadMessageCount = ((_a = item.threadMessageIds) === null || _a === void 0 ? void 0 : _a.length) || 1;
        item.convFids = [item.fid];
        item.receivedDate = item.sentDate;
        item.modifiedDate = item.sentDate;
        item.convId = 'CORP_MAIL_CONV_ID';
        item.isThread = true;
    });
    res.data.total = (_b = res === null || res === void 0 ? void 0 : res.data) === null || _b === void 0 ? void 0 : _b.data.total;
    res.data.building = false;
}
function transformRecallResult(res) {
    transformResultToVar(res);
    const recallResult = res.data.var;
    res.data.var = { recallResult };
}
function transformSearchResult(res) {
    var _a, _b;
    transformResultToVar(res);
    res.data.groupings = (_b = (_a = res === null || res === void 0 ? void 0 : res.data) === null || _a === void 0 ? void 0 : _a.data) === null || _b === void 0 ? void 0 : _b.groupings;
}
function getCorpFolderErrMsgByCode(code) {
    return CORP_FOLDER_ERRCODE_MAP[code] || CORP_DEFAULT_ERROR_MSG;
}
function transformCorpRelatedMailList(res) {
    const result = getCorpResponseDataFromResponse(res) || {};
    const resData = res.data.data;
    resData.emailInfoList = result.emailInfoList || [];
}
export function corpMailTransformResponse(res) {
    var _a, _b;
    const url = res.config.url;
    const urlPathName = getPathNameOfUrl(url);
    if (!urlPathName.includes('corp-mail/')) {
        return res;
    }
    const pathNameWithoutPrefix = urlPathName.replace(/^\/corp-mail\/mail\/api\//, '');
    if ((_a = res === null || res === void 0 ? void 0 : res.data) === null || _a === void 0 ? void 0 : _a.success) {
        res.data.code = MailAbstractHandler.sOk;
    }
    else {
        res.data.code = (_b = res === null || res === void 0 ? void 0 : res.data) === null || _b === void 0 ? void 0 : _b.message;
    }
    switch (pathNameWithoutPrefix) {
        case 'mail/folders':
            transformFolders(res);
            break;
        case 'mail/messages':
            transformMailList(res);
            break;
        case 'mail/message':
            transformMailItem(res);
            break;
        case 'mail/signatures':
            transformSignatures(res);
            break;
        case 'mail/messages/forward':
            transformForwardMail(res);
            break;
        case 'mail/message/infos':
            transformMailInfos(res);
            break;
        case 'mail/tags/manage':
            transformTagsManage(res);
            break;
        case 'mail/tags':
            transformTagList(res);
            break;
        case 'mail/compose':
            transformMailCompose(res);
            break;
        case 'mail/upload/prepare':
            transformPreUpload(res);
            break;
        case 'mail/threads':
            transformThreadList(res);
            break;
        case 'mail/message/recall':
            transformRecallResult(res);
            break;
        case 'mail/search':
            transformSearchResult(res);
            break;
        case 'mail/exchange/emailList':
            transformCorpRelatedMailList(res);
            break;
        default:
            transformResultToVar(res);
    }
    return res;
}
function getAllResultGroupInfo(total) {
    return {
        all: [{ val: -3, cnt: total }],
    };
}
const httpImpl = api.getDataTransApi();
function transformCorpCreateUserFolderParams(items) {
    if (!items || !items.length)
        return [];
    items.forEach(item => {
        if (!item.keepPeriod) {
            item.keepPeriod = -1;
        }
    });
    return items;
}
function buildUrlForCorpMail(key, additionalParam) {
    let url = getUrlByMailFuncName(key);
    if (!url) {
        url = '';
        return url;
    }
    const params = Object.assign({}, (additionalParam || {}));
    return httpImpl.buildUrl(url, params);
}
const htmlApi = api.requireLogicalApi(apis.htmlApi);
function handleCorpSignatureEl(item) {
    if (!item)
        return;
    const imgs = item.querySelectorAll('img');
    imgs.forEach(imgEl => {
        const originSrc = imgEl.getAttribute('src');
        if (originSrc.includes('/coremail') && (originSrc.includes('func=user:proxyGet') || originSrc.includes('user%3AproxyGet'))) {
            const searchInfo = htmlApi.parseUrlQuery(originSrc);
            imgEl.setAttribute('src', decodeURIComponent(searchInfo.url));
        }
    });
}
function getIsNeteaseMailUser() {
    const currentUser = systemApi.getCurrentUser();
    if (!currentUser)
        return false;
    const { domain } = currentUser;
    return NETEASE_DOMAIN_ARR.includes(domain);
}
function getWebUrlByFeatureName(featureName) {
    var _a;
    if (!featureName)
        return '';
    const isNeteaseMailUser = getIsNeteaseMailUser();
    if (!isNeteaseMailUser) {
        return '';
    }
    const urlInfo = FEATURE_NAME_TO_NETEASE_WEB_URL[featureName];
    if (!urlInfo) {
        return '';
    }
    const currentUser = systemApi.getCurrentUser();
    if (currentUser) {
        const hasQueryString = (_a = urlInfo.baseUrl) === null || _a === void 0 ? void 0 : _a.includes('?');
        return `${urlInfo.baseUrl}${hasQueryString ? '&' : '?'}sid=${currentUser.sessionId}#${urlInfo.hash}`;
    }
    return '';
}
function applyUnban(accountMsg) {
    try {
        const mainAccountEmail = systemApi.getMainAccount1().email;
        const unbanAccount = (accountMsg === null || accountMsg === void 0 ? void 0 : accountMsg.account) || mainAccountEmail;
        const unbanUrl = `https://fbhz.qiye.163.com/static/feedback/#/blackuser/${unbanAccount}`;
        systemApi.openNewWindow(unbanUrl, false);
    }
    catch (error) {
        console.log('申请解禁失败', error);
    }
}
export default {
    corpMailTransformResponse,
    getUrlByMailFuncName,
    getAllResultGroupInfo,
    transformCorpCreateUserFolderParams,
    getCorpFolderErrMsgByCode,
    buildUrlForCorpMail,
    handleCorpSignatureEl,
    getIsNeteaseMailUser,
    getWebUrlByFeatureName,
    applyUnban,
};
